import produce from 'immer';
import * as CONSTANTS from './constants';

const initialState = {
  googleLoginUrlState: {
    loading: false,
    success: false,
    error: false,
    authUrl: '',
  },
  company: null,
};

const contactImportReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CONSTANTS.FETCH_GOOGLE_LOGIN_URL_REQUEST:
        draft.googleLoginUrlState = {
          loading: true,
          success: false,
          error: false,
          authUrl: '',
        };
        break;
      case CONSTANTS.FETCH_GOOGLE_LOGIN_URL_SUCCESS:
        const { authUrl } = action.data;
        draft.googleLoginUrlState = {
          loading: false,
          success: true,
          error: false,
          authUrl,
        };
        break;
      case CONSTANTS.FETCH_GOOGLE_LOGIN_URL_FAIL:
        draft.googleLoginUrlState = {
          loading: false,
          success: false,
          error: action.error,
          authUrl: '',
        };
        break;

      case CONSTANTS.FETCH_COMPANY_DETAIL_REQUEST:
        draft.detail = { loading: true, error: null };
        break;
      case CONSTANTS.FETCH_COMPANY_DETAIL_SUCCESS:
        draft.company = action.data;
        draft.detail = { loading: false, error: null };
        break;
      case CONSTANTS.FETCH_COMPANY_DETAIL_FAIL:
        draft.detail = { loading: false, error: action.error };
        break;

      default:
        break;
    }
  });

export default contactImportReducer;
